import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Observable, catchError, throwError } from 'rxjs';

export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const isPublicApiCall = req.url.includes('/api/public/');

    let newReq = req.clone();

    if (
        !isPublicApiCall &&
        authService.accessToken &&
        !AuthUtils.isTokenExpired(authService.accessToken)
    ) {
        newReq = req.clone({
            headers: req.headers.set(
                'Authorization',
                'Bearer ' + authService.accessToken
            ),
        });
    }

    return next(newReq).pipe(
        catchError((error) => {
            if (
                !isPublicApiCall &&
                error instanceof HttpErrorResponse &&
                error.status === 401
            ) {
                authService.signOut();
                router.navigate(['/sign-in']);
            }

            return throwError(() => error);
        })
    );
};
